export const LOCAL_STORAGE_PROVIDER_KEY = 'jira_business_public-forms-changeboarding';
export const SHOW_FORM_BUILDER_SPOTLIGHTING_KEY = 'SHOULD_SHOW_FORM_BUILDER_SPOTLIGHTING';

export const PUBLIC_FORM_CHANGEBOARDING_SPOTLIGHTS_FORM_ACCESS_STEP =
	'PUBLIC_FORM_CHANGEBOARDING_SPOTLIGHTS_FORM_ACCESS_STEP';
export const PUBLIC_FORM_CHANGEBOARDING_SPOTLIGHTS_FORM_FIELD_STEP =
	'PUBLIC_FORM_CHANGEBOARDING_SPOTLIGHTS_FORM_FIELD_STEP';

/*
 * below is copied from the following file:
 * post-office/integrated-teams/jira-tanuki/message-templates/jira-forms-public-forms-changeboarding/src/placements/in-app/screen-space-flags/constants.tsx
 * */
export const MESSAGE_EVENT_ID = 'jira-forms-public-forms-changeboarding-event';
export const MESSAGE_TRIGGER_ID = 'jira-forms-public-forms-changeboarding-trigger-id';

export type MessageEventDetails = {
	action: 'skip' | 'showMe' | 'createForm' | 'filter' | 'viewed' | 'snooze';
};
